#import "../fragments/wf-form-fragment.graphql"

mutation connectedFormUnignore($input: ConnectedFormUnignoreInput!) {
    connectedFormUnignore(input: $input) {
        connectedForm {
            ...WfFormFragment
        }
    }
}
